import {
  GraphFilterTimeRangeOption,
  GraphFilterViewTypeOption,
} from './graph-filter.interface';

export const GraphFilterViewTypeOptions: GraphFilterViewTypeOption[] = [
  { label: 'Day', value: 1, isEnabled: false },
  { label: 'Week', value: 2, isEnabled: false },
  { label: 'Month', value: 3, isEnabled: false },
  { label: 'Quarter', value: 4, isEnabled: false },
  { label: 'Year', value: 5, isEnabled: false },
];

export const GraphFilterTimeRangeOptions: GraphFilterTimeRangeOption[] = [
  { label: '1D', value: 0 },
  { label: '1W', value: 1 },
  { label: '1M', value: 2 },
  { label: '6M', value: 3 },
  { label: '1Y', value: 4 },
];
